/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import * as _ from 'lodash'

// css
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import { TipDetailWrap } from './index.style'
import { TelegramSettingBtnWrap } from '@styles/button.style'
import DialogUtils from '@utils/dialog-utils'
import FloatingButtonImage from '@assets/images/banner/telegram-floating-button.png'
import Login from '@views/Login'

const TipDetailPopup: React.FC = () => {
  const { componentStore, authStore } = useRootStore()
  const { tipDetail } = componentStore

  const isTelegramTip = tipDetail?.order === 1

  const onShowTelegramSetting = () => {
    if (!authStore.isSignedIn) {
      authStore.showLoginPopup(<Login/>)
      return
    }
    DialogUtils.showTelegramSetting()
  }

  const renderTipDetailImg = (
    <div dangerouslySetInnerHTML={{ __html: tipDetail?.content }}/>
  )

  return (
    <TipDetailWrap>
      {!_.isEmpty(tipDetail?.content) && renderTipDetailImg}
      {isTelegramTip && (
        <TelegramSettingBtnWrap className="telegram-setting-btn-wrap">
          <div className="telegram-setting-tooltip">
            <span className="telegram-setting-tooltip--text">텔레그램 연동 혜택 받자!</span>
          </div>
          <button type="button" onClick={onShowTelegramSetting} className="telegram-setting-btn">
            <img src={FloatingButtonImage} alt="알림 설정하기"/>
          </button>
        </TelegramSettingBtnWrap>
      )}
    </TipDetailWrap>
  )
}
export default observer(TipDetailPopup)
